import React from 'react';
import SalesScreenOrganism from '../../organisms/SalesScreenOrganism/SalesScreenOrganism';

const SalesScreen = () => {
  return (
    <>
      <SalesScreenOrganism />
    </>
  );
};

export default SalesScreen;
